const s = require("../../../../components/downloadButton.module.scss");
import { default as React, useEffect } from "react";
import { Trans, withTranslation, WithTranslation } from "react-i18next";
import { ApplicationState } from "core/app";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faInfoCircle } from "@fortawesome/free-solid-svg-icons"; //fontawesome.com
import JaoLogo from "components/jaoLogo";
import { PageList } from "core/pages/pageList";

interface OwnState {
    applicationState: ApplicationState;
}

type PageProps = OwnState & WithTranslation;

export const page_config: PageList =
{
    apiUrl: "",
    webUrl: "home",
    menu: "", //no menu link should be created for this page
    apiType: "system",
    title: "menu:titleHome",
    response: "",
    dto: "",
    parameters: "",
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};

const Page = ({ t, applicationState }: PageProps) => {

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange("", false, false, []);
        })();
    }, [applicationState.selectedDate]);

    //CORE_PublicationHandbook = Redirect in web.config
    return (
        <div style={{ flex: "1", position: "relative", overflow: "auto" }}>
            <a href="CORE_PublicationHandbook" target="_blank" style={{ float: "right", margin: "2rem 0 2rem 2rem", color: "#88a4bf", textDecoration: "underline" }}>
                Publication handbook <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: "30px", verticalAlign: "middle", margin: "-6px 6px 0 6px" }} />
            </a>
            <JaoLogo />
            <div className="shadow-sm bg-white rounded m-3" style={{ padding: "20px" }}>
                <br />
                <h3>{t("page_home:welcomeTitle")}</h3>
                <Trans
                    defaults={t("page_home:text" + applicationState.environment)}
                    components={{ italic: <i />, bold: <strong />, paragraph: <p /> }}
                />
            </div>
        </div >
    );
}

export default withTranslation("page_home")(Page);
